import React, {Component, PropTypes} from 'react'
import {findDOMNode} from 'react-dom'
import {connect} from 'react-redux'
import {Row, Col, Nav, NavItem, Button, ButtonToolbar, PageHeader, Popover, Tooltip, Overlay, OverlayTrigger} from 'react-bootstrap'
import {connectLocationChangeLock} from '../../core/redux/router'
import {push} from '../../core/redux/router'
import {linkFinder} from '../../core/links'
import Icon from '../../core/components/Icon'
import {sendStartCampaignAction, sendFinishCampaignAction, loadCampaign} from '../actions'
import i18n from '../i18n'
import UpdateNotationScaleOfCampaignPopover from './UpdateNotationScaleOfCampaignPopover'
import UpdateTitleOfCampaignPopover from './UpdateTitleOfCampaignPopover'
import AddRemoveQuestionFromCampaignPopover from './AddRemoveQuestionFromCampaignPopover'
import DefineAnswerRateGoalPopover from './DefineAnswerRateGoalPopover'
import StartCampaignModal from './StartCampaignModal'
import FinishCampaignModal from './FinishCampaignModal'
import style from './CampaignDetail.less'

class CampaignDetail extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    _openPopover(event, name) {
        event.preventDefault()
        this.setState({openedPopover: name})
    }

    _closePopover(event) {
        if (event) {
            event.preventDefault()
        }
        
        const openedPopover = null
        this.setState({openedPopover})
    }

    _openModal(name) {
        this.setState({openedModal: name})
    }

    _closeModal() {
        this.setState({openedModal: null})
    }

    _sendStartAction() {
        const {dispatch} = this.props
        return dispatch(sendStartCampaignAction()).then(() => {
            return dispatch(loadCampaign())
        })
    }

    _sendFinishAction() {
        const {dispatch} = this.props
        return dispatch(sendFinishCampaignAction()).then(() => {
            return dispatch(loadCampaign())
        })
    }

    render() {
        const {children, dispatch, location, campaign} = this.props
        const {openedPopover, openedModal} = this.state
        const {editButton, editContainer} = this.refs

        const editMenuPopover = (
            <Popover>
                <ul className={style.menu}>
                    {campaign._links.find(linkFinder(['AddQuestionToCampaign', 'RemoveQuestionFromCampaign'])) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'AddRemoveQuestionFromCampaignPopover')}>
                                <span>> {i18n.questions}</span>
                            </a>
                        </li>
                    )}
                    {campaign._links.find(linkFinder('UpdateNotationScaleOfCampaign')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'UpdateNotationScaleOfCampaignPopover')}>
                                <span>> {i18n.notationScale}</span>
                            </a>
                        </li>
                    )}
                    {campaign._links.find(linkFinder('DefineAnswerRateGoal')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'DefineAnswerRateGoalPopover')}>
                                <span>> {i18n.answerRateGoal}</span>
                            </a>
                        </li>
                    )}
                    {campaign._links.find(linkFinder('UpdateTitleOfCampaign')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'UpdateTitleOfCampaignPopover')}>
                                <span>> {i18n.change}</span>
                            </a>
                        </li>
                    )}
                </ul>
            </Popover>
        )

        const editOverlay = (name, popover) => (
            <Overlay rootClose
                target={() => findDOMNode(editButton)}
                placement='bottom'
                show={openedPopover == name}
                container={editContainer}
                onHide={(e) => this._closePopover(e)}>
                {popover}
            </Overlay>
        )

        const tooltip = (text, status) => {
            return (
                <Tooltip className={status && 'tooltip-' + status}>
                    {text}
                </Tooltip>
            )
        }
        
        return (
            <div className={style.default}>
                <div className={style.defaultContent}>
                    <PageHeader className='large'>
                        <div
                            ref='editContainer'
                            className={style.header}>
                            <span>{i18n.campaign} - {campaign.title}</span>
                            <a
                                className={style.edit}
                                ref='editButton'
                                href=''
                                onClick={(e) => this._openPopover(e, 'EditMenuPopover')}
                                onMouseOver={(e) => this._openPopover(e, 'EditMenuPopover')}>
                                <Icon
                                    icon='gear'
                                    size='xs'
                                    active={openedPopover != null} />
                            </a>
                        </div>
                        {editOverlay('EditMenuPopover', editMenuPopover)}
                        {campaign._links.find(linkFinder(['AddQuestionToCampaign', 'RemoveQuestionFromCampaign'])) && editOverlay('AddRemoveQuestionFromCampaignPopover', (
                            <AddRemoveQuestionFromCampaignPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {campaign._links.find(linkFinder('UpdateNotationScaleOfCampaign')) && editOverlay('UpdateNotationScaleOfCampaignPopover', (
                            <UpdateNotationScaleOfCampaignPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {campaign._links.find(linkFinder('DefineAnswerRateGoal')) && editOverlay('DefineAnswerRateGoalPopover', (
                            <DefineAnswerRateGoalPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {campaign._links.find(linkFinder('UpdateTitleOfCampaign')) && editOverlay('UpdateTitleOfCampaignPopover', (
                            <UpdateTitleOfCampaignPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                    </PageHeader>
                    <Row>
                        <Col sm={4} smOffset={4}>
                            <ButtonToolbar>
                                {campaign._links.find(linkFinder('StartCampaign')) && (
                                    <Button
                                        bsStyle='primary'
                                        onClick={() => this._openModal('StartCampaignModal')}>
                                        {i18n.startCampaign}
                                    </Button>
                                )}
                                {campaign._links.find(linkFinder('FinishCampaign')) && (
                                    <Button
                                        bsStyle='danger'
                                        onClick={() => this._openModal('FinishCampaignModal')}>
                                        {i18n.finishCampaign}
                                    </Button>
                                )}
                            </ButtonToolbar>
                        </Col>
                    </Row>
                    <Nav justified
                        bsStyle='list'>
                        <NavItem
                            active={location.pathname.match(/\/\w+\/[\w-]+\/satisfactioncampaigns\/[\w-]+$/) != null}
                            onClick={() => dispatch(push('/*/*/satisfactioncampaigns/' + campaign.uid))}>
                            {i18n.synthesis}
                        </NavItem>
                        <NavItem
                            active={location.pathname.match(/\/\w+\/[\w-]+\/satisfactioncampaigns\/[\w-]+\/answers$/) != null}
                            onClick={() => dispatch(push('/*/*/satisfactioncampaigns/' + campaign.uid + '/answers'))}>
                            {i18n.answers}
                        </NavItem>
                    </Nav>
                </div>
                {children}
                {campaign._links.find(linkFinder('StartCampaign')) && (
                    <StartCampaignModal
                        show={openedModal == 'StartCampaignModal'}
                        onHide={() => this._closeModal()} />
                )}
                {campaign._links.find(linkFinder('FinishCampaign')) && (
                    <FinishCampaignModal
                        show={openedModal == 'FinishCampaignModal'}
                        onHide={() => this._closeModal()} />
                )}
            </div>
        )
    }
}

CampaignDetail = connectLocationChangeLock({
    pathName: /^\/\w+\/[\w-]+\/satisfactioncampaigns\/[\w-]+/
})(CampaignDetail)

CampaignDetail = connect((state) => ({
    location: state.router.location,
    campaign: state.satisfaction.campaign.campaign
}))(CampaignDetail)

export default CampaignDetail


// WEBPACK FOOTER //
// ./lib/satisfaction/components/CampaignDetail.js